import styled from 'styled-components';
import { layout, media } from 'src/components/base';

export const Header = styled.header`
  margin: ${layout.measurements.spacing150} 0;
`;

export const Wrapper = styled.section`
  padding: 0 ${layout.measurements.spacing100};
  margin-bottom: ${layout.measurements.spacing100};
`;

export const KeywordList = styled.ul.attrs({ 'data-test': 'KeywordList' })`
  list-style: none;
  margin-bottom: ${layout.measurements.spacing250};
  columns: 4;
  ${media.mediumDown`
    columns: 3;
  `};
  ${media.smallOnly`
    columns: 1;
  `};
`;

export const KeywordListItem = styled.li.attrs({
  'data-test': 'KeywordListItem',
})``;
